<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft-danger">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-danger p-4">
                           <h5 class="text-danger">Registro</h5>
                           <p>Envíenos sus datos y obtenga su cuenta.</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                  <router-link tag="a" to="/">
                     <div class="avatar-md profile-user-wid mb-4">
                        <span class="avatar-title rounded-circle bg-light">
                        <img src="@/assets/images/logo.png" alt class="rounded-circle" height="50" />
                        </span>
                     </div>
                  </router-link>
                  </div>

                  <b-alert v-model="registerSuccess" class="mt-3" variant="success" dismissible>Registration successfull.</b-alert>

                  <b-alert v-model="isRegisterError" class="mt-3" variant="danger" dismissible>{{regError}}</b-alert>

                  <b-form class="p-2" @submit.prevent="tryToRegisterIn">
                     <b-form-group id="email-group" label="Empresa" label-for="empresa">
                        <b-form-input id="empresa" v-model="empresa" type="text" placeholder="Introduzca el nombre de su empresa"></b-form-input>
                     </b-form-group>

                     <b-form-group id="fullname-group" label="Correo electrónico" label-for="email">
                        <b-form-input id="email" v-model="email" type="email" placeholder="Introduzca su correo electrónico de contacto"></b-form-input>
                     </b-form-group>

                     <div class="mt-4">
                        <b-button type="submit" variant="danger" class="btn-block">Envie petición de Registro</b-button>
                     </div>
                  </b-form>
               </div>
            </div>

            <div class="mt-5 text-center">
               <p>
                  ¿ Ya tiene una cuenta ?
                  <router-link tag="a" to="/login" class="font-weight-medium text-danger">Iniciar Sesión</router-link>
               </p>
               <p>© {{new Date().getFullYear()}} Portal ASEIN. Versión 1.0</p>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Account";
   export default {
      title: "Registro",
      data () {
         return {
            empresa: "",
            email: "",
            registerSuccess: false,
            isRegisterError: false,
            regError: null,
         }
      },
      components: {
         Layout
      },
      methods: {
         tryToRegisterIn() {
            this.tryingToRegister = true;
            this.regError = null;
            return (
               this.regError = "aaa"
               //this.register({
               //   email: this.email,
               //   password: this.password
               //})
               //.then(token => {
               //   this.tryingToRegister = false;
               //   this.isRegisterError = false;
               //   this.registerSuccess = true;
               //   if (this.registerSuccess) {
               //      this.$router.push(
               //         this.$route.query.redirectFrom || { name: "default" }
               //     );
               //   }
               //})
               //.catch(error => {
               //   this.tryingToRegister = false;
               //   this.regError = error ? error : "";
               //   this.isRegisterError = true;
               //})
            );
         }
      }
      
   }
</script>